import { useOpQuery } from './useOpQuery';

export const useFeatureGate = (
  featureCode: string | string[],
  orgId: number,
) => {
  const { data: orgFeatures, isPending } = useOpQuery({
    apiEndpointName: 'listOrgFeatures',
    parameters: [Number(orgId)],
    select: (res) => res.json.data,
  });

  const hasFeature = Boolean(
    orgFeatures?.some(({ code }) => {
      return Array.isArray(featureCode)
        ? Boolean(code && featureCode.includes(code))
        : featureCode === code;
    }),
  );

  return { hasFeature, isPending };
};
